<xpo-status-indicator [statusText]="statusText" [statusColor]="statusColor" [isLabel]="isLabel"></xpo-status-indicator>
